<template>
  <div class="templateTag" id="templateTag">
    <div style="height: 100%;">
      <!-- <div class="logoTemplate">
        <img width="80px" src="@/assets/0/logo.png">
      </div>-->
      <div class="clearfix" style="font-size: 22px;padding-top: 10px;color: #2C5D9E;background-color: #fff;">
        <i class="fr el-icon-setting" style="margin-right: 5px;" size="mini" @click="templateSet"></i>
        <div style="padding-left: 24px;">{{bigTitle}}</div>
        <el-divider></el-divider>
      </div>
      <mbManage ref="mbManage" @mbSearch="temSearch" :tit="indexTit" @getAT="mbHuidiao"></mbManage>
      <div v-show="newCreate" class="newCreate" id="newCreate">
        <el-card class="newCreate_card" :body-style="{padding: '0'}">
          <div @click="newClassClick">新增分组</div>
          <div @click="newTemp">新增模板</div>
        </el-card>
      </div>
      <newClass ref="newClass"></newClass>
      <!-- <TaskSearch ref='TaskSearch'></TaskSearch> -->
      <div class="contextmenu" :style="{height: height,}" @contextmenu.prevent="blankRC">
        <el-scrollbar style="height:100%;">
          <leftTree @getAllTask="getAllTask" ref="leftTree" :isBlank="isBlank" @getAllClass="getAllClass" @getTempLeft="getTempLeft" @leftSearch="temSearch" @newClassClick="newClassClick" @newTemp="newTemp" :ViewTypeState="ViewTypeState" :isViewType="isViewType" :isBrowseRecords="isBrowseRecordsSub"></leftTree>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetAllVisibleTemplateByUserId,
  GetAllTemplateByUserId
} from "@/api/modules/basicData/task";
import Sortable from "sortablejs";
import mbManage from "./mbManage.vue";
import leftTree from "./leftTree.vue";
import newClass from "./newClass.vue";
// import TaskSearch from '@/views/task/components/TaskSearch'
import searchJs from "@/util/search";
import { listToTree } from "@/api/modules/basicData/commonData";
export default {
  data() {
    return {
      thisTreeObj: {},
      inputVisible: false,
      inputValue: "",
      dialogVisible: false,
      createTimeFormat(time) {
        //格式化时间
        return time ? time.replace("T", " ").substr(0, 19) : "";
      },
      newCreate: false,
      temporary: [],
      isBrowseRecordsSub:this.isBrowseRecords,
      templateQuery:{},
      // tagItem: {},//当前模板对象
      // allVisibleTem: [],//左侧所有模板
    };
  },
  components: {
    mbManage,
    leftTree,
    newClass
    // TaskSearch
  },
  computed: {
    category: function() {
      return this.$store.state.task.category;
    },
    userId: function() {
      return this.$store.state.task.userId;
    }
    // allVisibleTem: function() {
    // 	return this.$store.state.task.allVisibleTem
    // },
  },
  watch: {},
  filters: {},
  props: {
    indexTit: String,
    bigTitle: String,
    // tempsType: String,
    columns: Array,
    isBlank: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: "calc(100% - 80px)"
    },
    isViewType: {
      type: Boolean,
      default: false
    },
    ViewTypeState: {
      type: Array,
      default: function() {
        return [];
      }
    },
    isBrowseRecords:{//是否显示浏览记录
      type: Boolean,
      default: false
    },
    // {
    // 	type: Array,
    // 	default: function() {
    // 		return [ // 列
    // 			{
    // 				text: "任务状态",
    // 				value: "TASKSTATENAME"
    // 			}, {
    // 				text: "任务名称",
    // 				value: "TASKNAME"
    // 			}, {
    // 				text: "创建人",
    // 				value: "CREATEUSERNAME"
    // 			}
    // 			// , {
    // 			// 	text: "创建时间",
    // 			// 	// value: "CREATETIME"
    // 			// 	value: `${"CREATETIME".replace("T", " ").substr(0, 19)}`
    // 			// },
    // 		]
    // 	}
    // }
  },
  mounted() {
    this.$store.state.task.columns = this.columns;
    let _this = this;
    document.onclick = function(e) {
      // 空引用时报错
      if (_this.$refs.leftTree) _this.$refs.leftTree.rClickLeft = false;
      _this.newCreate = false;
    };
    // this.getAlltempLeft();
    // setTimeout(() => {
    // 	this.moren();
    // },500)
    // this.getAllTemp()
    this.$store.commit("getAllTemplateLeft");
    this.$root.$on("createdTemp", data => {
      if (data) {
        this.createdGet();
      }
    });
  },
  methods: {
    getLeftAndAll(isLoadMenu) {
      // this.getAlltempLeft();
      this.$store.commit("getAllTemplateLeft",isLoadMenu);
      this.getAllTemp();
    },
    getTempLeft() {
      // this.getAlltempLeft()
      this.$store.commit("getAllTemplateLeft");
    },
    mbHuidiao() {
      this.createdGet();
    },
    getAllClass() {
      this.getAllTemp();
    },
    getAllTemp() {
      this.temporary = [];
      GetAllTemplateByUserId(this.userId, this.category).then(data => {
        // data.forEach((c) => {
        // 	if (c.TEMPTYPE != 2 && !c.PID) {
        // 		console.log('添加PID')
        // 		c.PID = 'zzz'
        // 	}
        // })
        // let temClass = [{
        // 	pid: '',
        // 	NAME: '默认分组',
        // 	ID: 'zzz',
        // 	TEMPTYPE: 2,
        // 	ICON: '我的任务.png',
        // 	ORDERINDEX: 0
        // }]
        let temClass = [];
        this.$store.state.task.allTemplate = data;
        console.log('aLLtEMPLATE=>>>', data)
        data.forEach(c => {
          if (c.TEMPTYPE == 2 || c.TEMPTYPE == 4) {
            temClass.push(c);
          }
        });
        this.$store.state.task.temClass = temClass;
        data.forEach(c => {
          if (c.TEMPTYPE !== 2 && c.TEMPTYPE !== 4) {
            this.temporary.push(c);
          }
        });

        let defaultData = data.filter(item => item.ISDEFAULT == true);
        if (defaultData.length > 0) {
          this.getAllTask(defaultData[0]);
        } else {
          this.$emit("firstLoad");
        }
      });
    },
    getAlltempLeft() {
      // 获取左侧所有模板
      // this.$refs.leftTree.GetAllVisibleTemp()
      this.$store.commit("getAllTemplateLeft");
    },
    getAllTask(data) {
      // 左侧点击树
      this.templateQuery=data;
      this.$emit("getAllTask", data);
      console.log(data, "-------------2");
      this.$store.state.task.hhh = true;
      // this.$store.state.task.tagItem = data;
    },
    blankRC(ev) {
      console.log("右击");
      this.newCreate = true;
      let dom = document.getElementById("newCreate");
      dom.style.top = ev.pageY + "px";
      dom.style.left = ev.pageX + "px";
    },
    newClassClick() {
      this.$refs.newClass.dialogVisible = true;
      this.getAllTemp();
    },
    temSearch(data) {
      this.$emit("openSearch", data);
    },
    newTemp() {
      // this.$refs.TaskSearch.taskSearchDialog = true;
      // this.$root.$emit('search',0);
      // this.$store.commit('createSearchTemp', 0);
      this.$emit("openSearch", 0);
      console.log("新增模板");
      this.getAllTemp();
    },
    allowDrop(draggingNode, dropNode, type) {
      if (!draggingNode.data.PID && !dropNode.data.PID) {
        return type !== "inner";
      }
    },
    allowDrag(draggingNode) {
      // console.log(draggingNode, "draggingNode")
      return draggingNode.data.label.indexOf("二级 3-2") === -1;
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {},
    templateSet() {
      this.getAllTemp();
      this.$refs.mbManage.temporary = this.temporary;
      // this.$refs.mbManage.temClass = this.temClass;
      this.$refs.mbManage.dialogVisible = true;
    },
    createdGet() {
      this.getAllTemp();
      console.log(this.temporary);
      this.$refs.mbManage.dormitory = this.temporary;
      this.$refs.mbManage.temporary = this.temporary;
    }
  }
};
</script>
<style lang="less">
  // .el-scrollbar /deep/ .el-scrollbar{
  //   /deep/ .el-scrollbar__wrap {
  //      overflow-x: hidden!important;
  //   }
  // }
</style>
<style scoped>
  .el-scrollbar >>> .el-divider--horizontal {
    margin: 5px 0;
  }

  .fixTemplate {
    color: #8f98a8;
  }

  .resultTemplate {
    color: #ffb25f;
  }

  .seekTemplate {
    color: #2b7cff;
  }

  .tagOver:hover {
    background-color: red;
  }

  .amendTag {
    z-index: 9999;
    position: absolute;
    top: 0;
    left: 0;
  }

  .amendTag .el-card__body {
    padding: 0;
  }

  .nowSearch,
  #tagDiv {
    display: inline-block;
  }

  #tagDiv {
    padding-left: 10px;
    position: relative;
    top: -2px;
    box-sizing: border-box;
  }

  .nowSearch {
    position: relative;
    top: -2px;
  }

  .amendTemplate {
    /* width: 115px; */
    background-color: #fff;

    cursor: pointer;
  }

  .amendTemplate li {
    size: 12px;
    padding: 5px 10px;
  }

  .amendTemplate li:hover {
    background-color: #ebf9ff;
    color: #5fb1ff;
  }

  .templateTag {
    box-sizing: border-box;
    width: 100%;
  }

  .newCreate {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
  }

  .newCreate_card {
    width: 75px;
  }

  .newCreate_card div {
    padding: 5px;
    cursor: pointer;
  }

  .newCreate_card div:hover {
    background-color: #ebf9ff;
    color: #5fb1ff;
  }

  /* .el-tag+.el-tag {
    		margin-left: 10px;
    	}

    	.button-new-tag {
    		margin-left: 10px;
    		height: 32px;
    		line-height: 30px;
    		padding-top: 0;
    		padding-bottom: 0;
    	}

    	.input-new-tag {
    		width: 90px;
    		margin-left: 10px;
    		vertical-align: bottom;
    	} */
</style>
